<script setup lang="ts">
import {useIsLoadingStore} from "~/store/loading.store";
import {RoleEnum} from "~/types/User";
import {useToast} from "~/components/ui/toast";
import {Switch} from "~/components/ui/switch";

const userStore = useUserStore();
const Loader = useIsLoadingStore();
const {toast} = useToast();
const {t} = useI18n();

const RoleSelection = computed(() => {
  if (userStore.currentRole !== RoleEnum.CUSTOMER) {
    return RoleEnum.CUSTOMER
  } else {
    return RoleEnum.MASTER
  }
})

async function UserRoleSetSummary() {
    await userStore.updateRole(RoleSelection.value)
        .then(() => {
            toast({
                title: t('Role updated successfully.'),
                variant: 'success',
            })
            Loader.set(false)
        }).finally(() => {
            Loader.set(false);
            navigateTo('/')
        })
}

</script>

<template>
  <Switch 
    :default-checked="userStore.currentRole === RoleEnum.MASTER"
    @click="UserRoleSetSummary" 
    class="data-[state=checked]:bg-primary-500"
    />
</template>